import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';


@Component({
    selector: 'eas-editor-eligibility-blueprints-form',
    templateUrl: './editor-eligibility-blueprints-form.component.html',
    styleUrls: ['./editor-eligibility-blueprints-form.component.css'],
    standalone: false
})
export class EditorEligibilityBlueprintsFormComponent implements OnInit {
  @Input() blueprintsFormArray: FormArray;

  private destroyed$ = new Subject<void>();

  blueprintNamesWithCategoryNames: { id: string, name: string, categoryNames: { id: string, name: string }[] }[];

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.blueprintNamesWithCategoryNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        blueprintNamesWithCategoryNames => {
          this.blueprintNamesWithCategoryNames = blueprintNamesWithCategoryNames;
        }
      );
  }

  onAdd() {
    this.blueprintsFormArray.push(
      new FormGroup({
        id: new FormControl(null),
        categories: new FormControl(null)
      })
    );
    return false;
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onDelete(index: number) {
    this.blueprintsFormArray.removeAt(index);
    return false;
  }

  toFormGroup(blueprintControl: AbstractControl) {
    return blueprintControl as FormGroup;
  }

  getCategoryNamesForBlueprint(blueprintId: string) {
    if (this.blueprintNamesWithCategoryNames === undefined) { return []; }

    return this.blueprintNamesWithCategoryNames.find(
      blueprintName => blueprintName.id === blueprintId
    )?.categoryNames ?? [];
  }
}
